import { render } from "./OrderHistoryDashboard.vue?vue&type=template&id=d311a9ac&scoped=true"
import script from "./OrderHistoryDashboard.vue?vue&type=script&lang=js"
export * from "./OrderHistoryDashboard.vue?vue&type=script&lang=js"

import "./OrderHistoryDashboard.vue?vue&type=style&index=0&id=d311a9ac&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d311a9ac"]])

export default __exports__